import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";
import { onError, onRecoverableError } from "~/entry.client.handlers";

export function hydrate() {
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <HydratedRouter onError={onError} />
      </StrictMode>,
      { onRecoverableError },
    );
  });
}
